(function () {
  'use strict';

  const element = document.currentScript ||
    document.querySelector('script[data-vivalle-tiktok-pixel]');
  const pixelId = String(element?.dataset?.vivalleTiktokPixel || '').trim();
  if (!/^[A-Z0-9]{20}$/.test(pixelId)) return;

  const stateKey = '__vivalleTikTokControlled_' + pixelId;
  if (window[stateKey]) return;
  const state = window[stateKey] = { initialized: false, sentOrderIds: new Set() };

  function consentAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function') return false;
    try { return Boolean(privacy.marketingAllowed()); }
    catch (_) { return false; }
  }

  function initialize() {
    if (state.initialized || !consentAllowed()) return false;

    if (typeof window.ttq?.load !== 'function') {
      window.TiktokAnalyticsObject = 'ttq';
      const queue = window.ttq = window.ttq || [];
      queue.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off',
        'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
      queue.setAndDefer = function (target, method) {
        target[method] = function () {
          target.push([method].concat(Array.prototype.slice.call(arguments)));
        };
      };
      for (const method of queue.methods) queue.setAndDefer(queue, method);
      queue.instance = function (id) {
        const instance = queue._i[id] || [];
        for (const method of queue.methods) queue.setAndDefer(instance, method);
        return instance;
      };
      queue.load = function (id, options) {
        const source = 'https://analytics.tiktok.com/i18n/pixel/events.js';
        queue._i = queue._i || {};
        queue._i[id] = [];
        queue._i[id]._u = source;
        queue._t = queue._t || {};
        queue._t[id] = Date.now();
        queue._o = queue._o || {};
        queue._o[id] = options || {};
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = source + '?sdkid=' + encodeURIComponent(id) + '&lib=ttq';
        const first = document.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(script, first);
      };
    }

    if (!window.ttq._i?.[pixelId]) window.ttq.load(pixelId);
    state.initialized = true;
    window.ttq.instance(pixelId).page();
    return true;
  }

  document.addEventListener('vivalle:order-confirmed', function (event) {
    const data = event?.detail || {};
    const value = Number(data.value);
    const orderId = String(data.event_id || '').trim();
    if (!orderId || !Number.isFinite(value) || value <= 0) return;
    if (state.sentOrderIds.has(orderId) || !consentAllowed()) return;
    const storageKey = 'vivalle_tiktok_purchase_' + pixelId + '_' + orderId;
    try { if (sessionStorage.getItem(storageKey) === '1') return; } catch (_) {}
    if (!state.initialized && !initialize()) return;

    try {
      window.ttq.instance(pixelId).track('Purchase', {
        value: value,
        currency: 'MAD',
        content_name: String(data.content_name || 'Vivalle'),
        content_type: 'product',
        content_id: String(data.content_id || ''),
        content_ids: [String(data.content_id || '')],
        quantity: Number(data.quantity) || 1,
        price: Number(data.price) || value,
        contents: [{
          content_id: String(data.content_id || ''),
          content_name: String(data.content_name || 'Vivalle'),
          content_type: 'product',
          quantity: Number(data.quantity) || 1,
          price: Number(data.price) || value
        }]
      }, { event_id: orderId });
      state.sentOrderIds.add(orderId);
      try { sessionStorage.setItem(storageKey, '1'); } catch (_) {}
    } catch (err) {
      console.error('[Vivalle TikTok] Purchase could not be queued:', err);
    }
  });

  document.addEventListener('visitorConsentCollected', initialize);
  if (window.Shopify?.customerPrivacy) {
    initialize();
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) { if (!error) initialize(); }
    );
  } else {
    window.addEventListener('load', initialize, { once: true });
  }
})();
